document.addEventListener('DOMContentLoaded', () => {

  const qtyInput = document.querySelector('.quantity__input');
  const hiddenVariants = document.querySelectorAll('.hidden-variant-options input[name="qty_variant"]');
  const productForm = document.querySelector('form[action*="/cart/add"].form');
  const variantIdInput = productForm?.querySelector('input[name="id"]');
  const priceRegular = document.querySelector('.price .price-item--regular');
  const priceSale = document.querySelector('.price .price-item--sale');
  const saleContainer = document.querySelector('.price__sale');
  const callBtn = document.querySelector('.call-inquiry-btn');
  const addToCartBtn = document.querySelector('.product-form__submit');
  const each = document.querySelector('.each');
  const priceWrap = document.querySelector('.price_wrap');

  let lastAvailableVariant = null;

  if (!qtyInput || !hiddenVariants.length || !variantIdInput) {
    console.warn('[Qty→Variant] Missing required elements.');
    return;
  }

  const formatCurrency = value =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: Shopify.currency.active
    }).format(value);

  function parseRange(title) {
    const rangeMatch = title.match(/(\d+)\s*-\s*(\d+)/);
    if (rangeMatch) return { min: +rangeMatch[1], max: +rangeMatch[2] };
    const singleMatch = title.match(/^(\d+)$/);
    if (singleMatch) {
      const val = +singleMatch[1];
      return { min: val, max: val };
    }
    return null;
  }

  function findVariantForQuantity(qty) {
    for (const input of hiddenVariants) {
      const range = parseRange(input.dataset.title);
      if (range && qty >= range.min && qty <= range.max) {
        if (!input.disabled) return input; // only if available
      }
    }
    return null;
  }

  function getHighestRangeMax() {
    let max = 0;
    hiddenVariants.forEach(v => {
      const range = parseRange(v.dataset.title);
      if (range && range.max > max) max = range.max;
    });
    return max;
  }

  function showInquiryMode() {
    if (callBtn) callBtn.classList.remove('hidden');
    if (addToCartBtn) addToCartBtn.style.display = 'none';
    if (priceWrap) priceWrap.style.display = 'none';
    if (priceRegular) priceRegular.textContent = '';
    if (each) each.style.display = 'none';
    if (saleContainer) saleContainer.style.display = 'none';
  }

  function hideInquiryMode(price, compareAt) {
    if (callBtn) callBtn.classList.add('hidden');
    if (addToCartBtn) addToCartBtn.style.display = '';
    if (priceWrap) priceWrap.style.display = '';
    if (each) each.style.display = '';
    updatePriceDisplay(price, compareAt);
  }

  function updatePriceDisplay(price, compareAt) {
    if (!priceRegular) return;
    if (compareAt && compareAt > price) {
      saleContainer?.classList.add('price--on-sale');
      priceRegular.textContent = formatCurrency(compareAt);
      priceSale.textContent = formatCurrency(price);
      saleContainer.style.display = 'block';
    } else {
      saleContainer?.classList.remove('price--on-sale');
      priceRegular.textContent = formatCurrency(price);
      if (priceSale) priceSale.textContent = '';
      saleContainer.style.display = 'none';
    }
  }

  function handleQtyChange() {
    const qty = parseInt(qtyInput.value, 10);
    if (isNaN(qty) || qty < 1) return;

    const match = findVariantForQuantity(qty);
    const highestMax = getHighestRangeMax();

    // Case 1: within a valid available variant
    if (match) {
      hiddenVariants.forEach(v => (v.checked = false));
      match.checked = true;
      variantIdInput.value = match.value;
      productForm.querySelector('.product-variant-id').value = match.value;
      lastAvailableVariant = match;

      const price = parseFloat(match.dataset.price || 0);
      const compareAt = parseFloat(match.dataset.compareAt || 0);
      hideInquiryMode(price, compareAt);
      return;
    }

    // Case 2: quantity beyond all defined ranges → show inquiry
    if (qty > highestMax) {
      showInquiryMode();
      return;
    }

    // Case 3: quantity inside a missing/unavailable range → keep last available
    if (lastAvailableVariant) {
      lastAvailableVariant.checked = true;
      variantIdInput.value = lastAvailableVariant.value;
      productForm.querySelector('.product-variant-id').value = lastAvailableVariant.value;
      const price = parseFloat(lastAvailableVariant.dataset.price || 0);
      const compareAt = parseFloat(lastAvailableVariant.dataset.compareAt || 0);
      hideInquiryMode(price, compareAt);
      return;
    }

    // Otherwise: default to inquiry
    showInquiryMode();
  }

  productForm?.addEventListener('submit', e => {
    const qty = parseInt(qtyInput.value, 10);
    const match = findVariantForQuantity(qty) || lastAvailableVariant;
    if (match) {
      variantIdInput.value = match.value;
      productForm.querySelector('.product-variant-id').value = match.value;
    }
  });

  qtyInput.addEventListener('input', handleQtyChange);
  document.querySelectorAll('.quantity__button').forEach(btn =>
    btn.addEventListener('click', () => setTimeout(handleQtyChange, 100))
  );

  handleQtyChange();
});
